angular
    .module('MW.ContactManager.SelectionFactory', [
        'MW.Framework.InfluencerContactService',
        'MW.Framework.ICMUserService'

    ])
    .factory('FilterSelectionFactory', [
        '$q',
        'ICMUserService',
        'moment',
        function ($q, ICMUserService, moment) {
            'use strict';
            function FilterSelectionFactory(name) {
                this.init(name);
            }

            FilterSelectionFactory.prototype.init = function init(name) {
                this.ICMUserService = ICMUserService;
                this.moment = moment;
                this.currentOptions = [];
                this.displayState = {
                    selected: {},
                    selectionDisplay: '',
                    selectedCount: 0,
                    partiallySelected: {},
                    allSelected: false
                };
                this.name = name;
                this.history = [];
                this.parent = null;

                this.previousState = {};
            };

            FilterSelectionFactory.prototype.getSelection = function getSelection() {
                return this.displayState.selected;
            };

            FilterSelectionFactory.prototype.toggle = function toggle(option, updateAncestors) {
                if (this.isSelected(option)) {
                    this.deselect(option, updateAncestors);
                    this.displayState.allSelected = false;
                } else {
                    this.select(option, updateAncestors);
                    this.displayState.allSelected = this.isPageFullySelected();
                }
            };

            FilterSelectionFactory.prototype.toggleAllCurrent = function toggleAllCurrent() {
                if (this.isPageFullySelected()) {
                    this.currentOptions.forEach(function (currentOption) {
                        if (this.isSelected(currentOption)) {
                            this.deselect(currentOption);
                        }
                    }, this);

                    this.displayState.allSelected = false;
                } else {
                    this.currentOptions.forEach(function (currentOption) {
                        if (!this.isSelected(currentOption)) {
                            this.select(currentOption);
                        }
                    }, this);

                    this.displayState.allSelected = true;
                }
            };

            FilterSelectionFactory.prototype.isSelected = function isSelected(option) {
                return !!this.displayState.selected[option.key];
            };

            FilterSelectionFactory.prototype.isPageFullySelected = function isPageFullySelected() {
                if (!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
                    return false;
                }

                return this.currentOptions.every(function (currentOption) {
                    return this.isSelected(currentOption);
                }, this);
            };

            FilterSelectionFactory.prototype.reset = function reset() {
                this.init();
            };

            FilterSelectionFactory.prototype.snapshotState = function snapshotState() {
                this.previousState = angular.copy(this.displayState);
            };

            FilterSelectionFactory.prototype.rollback = function rollback() {
                this.displayState = this.previousState;
                this.previousState = {};
            };

            FilterSelectionFactory.prototype.select = function select(option, updateAncestors) {
                if (this.isPartiallySelected(option)) {
                    this.removePartialSelection(option);
                }

                if(this.parent) {
                    option.parentKey = this.parent.key;
                }

                this.displayState.selected[option.key] = option;

                this.updateAllSelected();

                if(option.children) {
                    option.children.forEach(function(childOption) {
                        childOption.parentKey = option.key;
                        this.displayState.selected[childOption.key] = childOption;
                    }, this);
                }

                if (updateAncestors) {
                    this.updateAncestors(option);
                }

                this.updateRecentDisplay();
            };

            FilterSelectionFactory.prototype.selectByKey = function selectByKey(key) {
                var option = this.currentOptions.filter(function(obj) {
                    return obj.key === key;
                });
                if (option[0]) {
                    this.select(option[0]);
                }
            };

            FilterSelectionFactory.prototype.deselectAll = function deselectAll() {
                this.currentOptions.forEach(function(currentOption) {
                    if (this.isSelected(currentOption) || this.isPartiallySelected(currentOption)) {
                        this.deselect(currentOption);
                    }
                }, this);
                this.updateRecentDisplay();
            };

            FilterSelectionFactory.prototype.deselect = function deselect(option, updateAncestors) {
                if (this.isPartiallySelected(option)) {
                    this.removePartialSelection(option);
                }

                delete this.displayState.selected[option.key];

                this.displayState.allSelected = false;

                if(option.children) {
                    option.children.forEach(function(childOption) {
                        delete this.displayState.selected[childOption.key];
                    }, this);
                }

                if (updateAncestors) {
                    this.updateAncestors(option);
                }

                this.updateRecentDisplay();
            };

            FilterSelectionFactory.prototype.updateRecentDisplay = function updateRecentDisplay() {
                this.displayState.selectedCount = this.selectedCurrentOptionCount();
                if (this.displayState.selectedCount === 0) {
                    this.displayState.selectionDisplay = '';
                } else if (this.displayState.selectedCount === 1) {
                    this.displayState.selectionDisplay = this.displayState.selected[this.getSelectedValues()[0]].display;
                } else {
                    this.displayState.selectionDisplay = this.name;
                }
            };

            FilterSelectionFactory.prototype.updateAncestors = function updateAncestors(option) {
                if (option.parentKey) {
                    this.updateParent(option);
                }
            };

            FilterSelectionFactory.prototype.updateCurrentOptions = function updateCurrentOptions(relevantOptions) {
                this.currentOptions = relevantOptions;

                // if nothing is selected no need to update
                if (Object.keys(this.displayState.selected).length) {
                    // this call will always be made when we are at the parent level, so just update parent display states
                    // also this should only be called with new beats that cannot yet be selected
                    this.currentOptions.forEach(function (parentOption) {
                        if (this.isSelected(parentOption) || this.isPartiallySelected(parentOption)) {
                            this.updateParent(null, parentOption);
                        }
                    }, this);
                }

                this.displayState.allSelected = this.isPageFullySelected();
            };

            FilterSelectionFactory.prototype.partiallySelect = function partiallySelect(option) {
                if (this.isSelected(option)) {
                    delete this.displayState.selected[option.key];
                    this.displayState.allSelected = false;
                }

                this.displayState.partiallySelected[option.key] = option;
            };

            FilterSelectionFactory.prototype.isPartiallySelected = function isPartiallySelected(option) {
                return !!this.displayState.partiallySelected[option.key];
            };

            FilterSelectionFactory.prototype.openChild = function openChild(option) {
                return $q(function(resolve) {
                    if (!option.children.length) {
                        return;
                    }

                    this.history.push({
                        options: this.currentOptions,
                        parent: this.parent
                    });

                    this.currentOptions = option.children;
                    this.parent = option;

                    if (this.isSelected(this.parent)) {
                        this.currentOptions.forEach(function(option) {
                            this.select(option);
                        }, this);

                        this.displayState.allSelected = true;
                    } else if (this.isPartiallySelected(this.parent)) {
                        this.displayState.allSelected = false;
                    } else {
                        this.currentOptions.forEach(function(option) {
                            this.deselect(option);
                        }, this);

                        this.displayState.allSelected = false;
                    }

                    resolve();
                }.bind(this));
            };

            FilterSelectionFactory.prototype.openParent = function openParent() {
                if (!this.history.length) {
                    return;
                }

                var historyObject = this.history.pop();

                // before drilling back up, check children
                // if all children are selected, select the parent
                // if page is partially selected, partially select parent
                if (this.isPageFullySelected()) {
                    this.select(this.parent);
                } else if (this.isPagePartiallySelected()) {
                    this.partiallySelect(this.parent);
                } else {
                    this.deselect(this.parent);
                }

                this.currentOptions = historyObject.options;
                this.parent = historyObject.parent;

                // after drilling up, check if everything at this level is selected
                this.displayState.allSelected = this.isPageFullySelected();
            };

            FilterSelectionFactory.prototype.getParent = function getParent(option) {
                var parent = null;

                if (this.parent) { // then we are on the child view
                    parent = this.parent;
                } else { // we are on the parent view
                    this.currentOptions.some(function (parentOption) {
                        if (parentOption.key === option.parentKey) {
                            parent = parentOption;
                            return true;
                        }
                    });
                }

                return parent;
            };

            FilterSelectionFactory.prototype.updateParent = function updateParent(child, parent) {
                var numberOfChildren = 0,
                    numberOfSelectedChildren = 0;

                parent = parent || this.getParent(child);

                if (parent.children) {
                    // get the count of children selected
                    numberOfChildren = parent.children.length;
                    parent.children.forEach(function (child) {
                        if (this.isSelected(child)) {
                            numberOfSelectedChildren++;
                        }
                    }, this);

                    // set the parent's display state, based on the number of children selected
                    if (numberOfSelectedChildren === 0) {
                        delete this.displayState.selected[parent.key];
                        delete this.displayState.partiallySelected[parent.key];
                    } else if (numberOfSelectedChildren === numberOfChildren) {
                        this.displayState.selected[parent.key] = parent;
                        delete this.displayState.partiallySelected[parent.key];
                    } else {
                        delete this.displayState.selected[parent.key];
                        this.displayState.partiallySelected[parent.key] = parent;
                    }
                }
            };

            FilterSelectionFactory.prototype.updateAllSelected = function updateAllSelected() {
                var isAllSelected = false;

                if (Object.keys(this.displayState.selected).length) {
                    isAllSelected = this.currentOptions.every(function (option) {
                        return this.isSelected(option);
                    }, this);
                }

                this.displayState.allSelected = isAllSelected;
            };

            FilterSelectionFactory.prototype.removePartialSelection = function removePartialSelection(option) {
                delete this.displayState.partiallySelected[option.key];
            };

            FilterSelectionFactory.prototype.getSelectedChildren = function getSelectedChildren() {
                var selectedChildren = [];

                if (!_.isEmpty(this.displayState.selected)) {
                    Object.keys(this.displayState.selected).forEach(function (key) {
                        if (!this.displayState.selected[key].children) {
                            selectedChildren.push(this.displayState.selected[key]);
                        }
                    }, this);
                }    

                return selectedChildren;
            };

            FilterSelectionFactory.prototype.isPagePartiallySelected = function isPagePartiallySelected() {
                var selectedCount = 0,
                    partiallySelectedCount = 0;

                if (!Array.isArray(this.currentOptions) || !this.currentOptions.length) {
                    return false;
                }

                this.currentOptions.forEach(function (currentOption) {
                    if (this.isSelected(currentOption)) {
                        selectedCount++;
                    } else if (this.isPartiallySelected(currentOption)) {
                        partiallySelectedCount++;
                    }
                }, this);

                return ((partiallySelectedCount > 0) || ((selectedCount > 0) && (selectedCount < this.currentOptions.length)));
            };

            FilterSelectionFactory.prototype.selectedCurrentOptionCount = function selectedCurrentOptionCount() {
                var selectedCount = 0;

                this.currentOptions.forEach(function(currentOption) {
                    if (currentOption.children) {
                        currentOption.children.forEach(function(childOption) {
                            if (this.isSelected(childOption)) {
                                selectedCount++;
                            }
                        }, this);
                    }
                    else if (this.isSelected(currentOption)) {
                        selectedCount++;
                    }
                }, this);

                return selectedCount;
            };

            FilterSelectionFactory.prototype.resetDepth = function resetDepth() {
                if(this.history.length > 0) {
                    this.openParent();
                    this.resetDepth();
                }
            };

            FilterSelectionFactory.prototype.hasChildren = function hasChildren(option) {
                return (Array.isArray(option.children) && option.children.length);
            };

            FilterSelectionFactory.prototype.getSelectedChildCount = function getSelectedChildCount(parent) {
                var childCount = 0;

                Object.keys(this.displayState.selected).forEach(function(selectedKey) {
                    var selectedOption = this.displayState.selected[selectedKey];

                    if(selectedOption.parentKey === parent.key) {
                        childCount++;
                    }
                }, this);

                return childCount;
            };

            FilterSelectionFactory.prototype.getSelectedValues = function getSelectedValues() {
                return Object.keys(this.displayState.selected);
            };

            return FilterSelectionFactory;
        }
    ])
    .factory('LocationSelectionFactory', [
        'FilterSelectionFactory',
        'InfluencerContactService',
        '$q',
        function (FilterSelectionFactory, InfluencerContactService, $q) {
            'use strict';

            function LocationSelectionFactory(name) {
                FilterSelectionFactory.call(this, name);

                this.InfluencerContactService = InfluencerContactService;
                this.querySelections = [];

                this.levels = {
                    COUNTRY: 'country',
                    REGION: 'region',
                    CITY: 'city'
                };

                this.getQuerySelections = function getQuerySelections() {
                    return this.querySelections;
                };

                this.getQuerySelectionCount = function getQuerySelectionCount() {
                    return this.querySelections.length;
                };

                this.hasChildren = function locationHasChildren(option) {
                    switch(option.level.toLowerCase()) {
                        case this.levels.COUNTRY:
                        case this.levels.REGION:
                            return true;
                        default:
                            return false;
                    }
                };

                this.updateQuery = function updateQuery(queryString, filters, searchType, chips, dateRangeDays, language) {
                    this.queryString = queryString;
                    this.filters = filters;
                    this.searchType = searchType;
                    this.chips = chips;
                    this.dateRangeDays = dateRangeDays || 14;
                    this.language = language;
                };

                this.openChild = function openChild(option, cb) {
                    var _this = this;

                    return $q(function(resolve, reject) {
                        if(option.level.toLowerCase() === _this.levels.REGION) {
                            var searchTypeFunction,
                                allSearchTypeFunction,
                                query = {
                                    aggregations: [
                                        {
                                          type: 'cities',
                                          country: option.country,
                                          region: option.key
                                        }
                                    ],
                                    filters: _this.filters || [],
                                    page: 0,
                                    pageSize: 0,
                                    q: _this.queryString || '',
                                    orQ: _this.chips || [],
                                    language: _this.language
                                },
                                promises = [];

                            if (_this.searchType === 'source' || (_this.searchType === 'relevantSource' && query.orQ.length === 0)) {
                                _this.searchType = 'source';
                                searchTypeFunction = allSearchTypeFunction = _this.InfluencerContactService.aggregateSourceSearch;
                            }
                            else if (_this.searchType === 'relevantContact' && query.orQ.length === 0) {
                                _this.searchType = 'contact';
                                searchTypeFunction = allSearchTypeFunction = _this.InfluencerContactService.aggregateContactSearch;
                            }
                            else if (_this.searchType === 'relevantContact') {
                                searchTypeFunction = _this.InfluencerContactService.aggregateRelevantContacts;
                                allSearchTypeFunction =_this.InfluencerContactService.aggregateContactSearch;
                                query.relevantQ = query.q;
                                delete query.q;
                            }
                            else if (_this.searchType === 'relevantSource') {
                                searchTypeFunction = _this.InfluencerContactService.aggregateRelevantSources;
                                allSearchTypeFunction = _this.InfluencerContactService.aggregateSourceSearch;
                                query.relevantQ = query.q;
                                delete query.q;
                            }
                            else {
                                _this.searchType = 'contact';
                                searchTypeFunction = allSearchTypeFunction = _this.InfluencerContactService.aggregateContactSearch;
                            }

                            if (_this.searchType.indexOf('relevant') === 0) {
                                query.docQuery = {
                                    dateStart: _this.moment().tz(_this.ICMUserService.getTimezone()).subtract(_this.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
                                    dateEnd: _this.moment().tz(_this.ICMUserService.getTimezone()).endOf('day').toISOString()
                                };
                            }

                            // query for all cities as well as relevant cities
                            var queryNoFilters = angular.copy(query);
                            queryNoFilters.filters = [];
                            queryNoFilters.q = '';
                            delete queryNoFilters.relevantQ;
                            delete queryNoFilters.orQ;
                            delete queryNoFilters.docQuery;
                            promises.push(allSearchTypeFunction(queryNoFilters));
                            promises.push(searchTypeFunction(query));
                            $q.all(promises)
                                .then(function successAggregateSearch(resolvedPromises) {

                                    function makeHash(array, boolIsOkay) {
                                        var hashMap = {};
                                        array.forEach(function(option) {
                                            hashMap[option.key] = boolIsOkay ? true : option;
                                        });
                                        return hashMap;
                                    }

                                    var noFilterResponse = resolvedPromises[0],
                                        relevantResponse = resolvedPromises[1],
                                        finalList  = [];

                                    if(noFilterResponse.aggs && noFilterResponse.aggs.cities && relevantResponse.aggs && relevantResponse.aggs.cities) {
                                        var allHash = makeHash(noFilterResponse.aggs.cities),
                                            relevantHash = makeHash(relevantResponse.aggs.cities);

                                        // for every avail options, see if it is relevant
                                        Object.keys(allHash).forEach(function(allKey) {
                                            allHash[allKey].count = relevantHash[allKey] ? relevantHash[allKey].count : 0;
                                            if(!relevantHash[allKey]) {
                                                allHash[allKey].nonRelevant = true;
                                            }
                                        });

                                        // convert back to array
                                        Object.keys(allHash).forEach(function(tempKey) {
                                            finalList.push(allHash[tempKey]);
                                        });
                                    }

                                    option.children = finalList;
                                })
                                .catch(function failedAggregateSearch(error) {
                                    reject(error);
                                })
                                .finally(function finallyAggregateSearch() {
                                    _openChild();
                                    if (cb && typeof cb === 'function') {
                                        cb();
                                    }
                                });
                        } else {
                            _openChild();
                            if(cb && typeof cb === 'function'){
                                cb();
                            }

                        }

                        function _openChild() {
                            if (!option.children.length) {
                                return;
                            }

                            _this.history.push({
                                options: _this.currentOptions,
                                parent: _this.parent
                            });

                            _this.currentOptions = option.children;
                            _this.parent = option;

                            if (_this.isSelected(_this.parent)) {
                                _this.currentOptions.forEach(function(option) {
                                    _this.addQuerySelection(option, true);
                                    _this.addToDisplay(option);
                                });

                                _this.displayState.allSelected = true;
                            } else if (_this.isPartiallySelected(_this.parent)) {
                                _this.displayState.allSelected = false;

                                if(_this.parent.level.toLowerCase() === _this.levels.COUNTRY) {
                                    _this.currentOptions.forEach(function(regionOption) {
                                        if(!_this.isSelected(regionOption) && !_this.isPartiallySelected(regionOption)) {
                                            _this.querySelections.some(function(querySelection) {
                                                if((regionOption.key === querySelection.region) && (querySelection.level.toLowerCase() === _this.levels.CITY)) {
                                                    _this.partiallySelect(regionOption);

                                                    return true;
                                                }
                                            });
                                        }
                                    });
                                }
                            } else {
                                _this.currentOptions.forEach(function(option) {
                                    _this.removeFromDisplay(option);
                                });

                                _this.displayState.allSelected = false;
                            }

                            resolve();
                        }
                    });
                };

                this.openParent = function openParent() {
                    if (!this.history.length) {
                        return;
                    }

                    var historyObject = this.history.pop();

                    // before drilling back up, check children
                    // if all children are selected, select the parent
                    // if page is partially selected, partially select parent
                    if (this.isPageFullySelected()) {
                        this.addToDisplay(this.parent);
                    } else if (this.isPagePartiallySelected()) {
                        this.partiallySelect(this.parent);
                    } else {
                        this.removeFromDisplay(this.parent);
                    }

                    this.currentOptions = historyObject.options;
                    this.parent = historyObject.parent;

                    // after drilling up, check if everything at this level is selected
                    this.displayState.allSelected = this.isPageFullySelected();
                };

                this.partiallySelect = function partiallySelect(option) {
                    if (this.isSelected(option)) {
                        this.removeFromDisplay(option);
                    }

                    this.displayState.partiallySelected[option.key] = option;
                };

                this.addToDisplay = function addToDisplay(option) {
                    if (this.isPartiallySelected(option)) {
                        this.removePartialSelection(option);
                    }

                    this.displayState.selected[option.key] = option;
                    this.updateAllSelected();
                };

                this.removeFromDisplay = function removeFromDisplay(option) {
                    if (this.isPartiallySelected(option)) {
                        this.removePartialSelection(option);
                    }

                    // for city, the option.key is an UUID. it is not the same as the key in the selected list.
                    delete this.displayState.selected[option.name];
                    delete this.displayState.selected[option.key];
                    this.displayState.allSelected = false;
                };

                this.updateRecentDisplay = function updateRecentDisplay() {
                    this.displayState.selectedCount = this.getQuerySelectionCount();
                    if (this.displayState.selectedCount === 0) {
                        this.displayState.selectionDisplay = '';
                    } else if (this.displayState.selectedCount === 1) {
                        this.displayState.selectionDisplay = this.getQuerySelections()[0].display;
                    } else {
                        this.displayState.selectionDisplay = this.name;
                    }
                };

                this.select = function select(option) {
                    this.addQuerySelection(option);
                    this.addToDisplay(option);
                    this.updateRecentDisplay();
                };

                this.deselect = function deselect(option) {
                    this.removeQuerySelection(option);
                    this.removeFromDisplay(option);
                    this.updateRecentDisplay();
                };

                this.findQuerySelection = function findQuerySelection(option) {
                    var found = -1;

                    this.querySelections.some(function(querySelection, index) {
                        if((querySelection.key === option.key || querySelection.key === option.name) && (querySelection.level === option.level)) {
                            found = index;
                            return true;
                        }
                    });

                    return found;
                };

                this.addQuerySelection = function addQuerySelection(option, forceAdd) {
                    var alreadySelectedAt = -1,
                        ancestorSelected = false;

                    ancestorSelected = this.querySelections.some(function(querySelection, index) {
                        if((querySelection.key === option.key) && (querySelection.level === option.level)) {
                            alreadySelectedAt = index;
                        }

                        if(querySelection.key === option[querySelection.level]) {
                            return true;
                        }
                    });

                    // only add if not already selected & ancestor not selected
                    if((alreadySelectedAt < 0) && !ancestorSelected) {
                        this.querySelections.push(option);
                    }

                    // trying to add the children when drilling down the tree
                    if (forceAdd && !this.isSelected(option)) {
                        this.querySelections.push(option);
                    }

                    // deselect any descendants
                    this.querySelections = this.querySelections.filter(function(querySelection) {
                        return (querySelection[option.level] !== option.key);
                    });
                };

                this.removeQuerySelection = function removeQuerySelection(option) {
                    var foundAt;

                    // strip all desendants & ancestors
                    this.querySelections = this.querySelections.filter(function (querySelection) {
                        // deselect any descendants
                        if (querySelection[option.level] === option.key) {
                            return false;
                        }

                        // deselect parent regions
                        if (option.region === querySelection.key) {
                            return false;
                        }

                        // deselect parent countries
                        if (option.country === querySelection.key) {
                            return false;
                        }

                        return true;
                    });

                    // if this page was fully selected, add all current options
                    if(this.isPageFullySelected()) {
                        this.currentOptions.forEach(function(option) {
                            this.addQuerySelection(option);
                        }, this);
                    }

                    // strip out the deselected option
                    foundAt = this.findQuerySelection(option);
                    if(foundAt >= 0) {
                        this.querySelections.splice(foundAt, 1);
                    }
                };

                this.snapshotState = function snapshotState() {
                    this.previousState = {
                        display: angular.copy(this.displayState),
                        selection: angular.copy(this.querySelections)
                    };
                };

                this.rollback = function rollback() {
                    this.displayState = this.previousState.display;
                    this.querySelections = this.previousState.selection;
                    this.previousState = {};
                };

                this.reset = function reset() {
                    this.querySelections = [];
                    this.init();
                };

                this.getSelectedChildCount = function getSelectedChildCount(parent) {
                    var parentKey = parent.key,
                        parentLevel = parent.level,
                        childCount = 0;

                    this.querySelections.forEach(function(querySelection) {
                        if(querySelection[parentLevel] === parentKey) {
                            childCount++;
                        }
                    });

                    return childCount;
                };

                this.updateCurrentOptions = function updateCurrentOptions(options) {
                    var childCounts = {};

                    this.currentOptions = options;

                    function _createChildCountObject(country) {
                        childCounts[country] = {
                            selectedRegions: 0,
                            selectedCities: 0
                        };
                    }

                    if (this.querySelections.length) {
                        this.querySelections.forEach(function(querySelection) {
                            switch(querySelection.level.toLowerCase()) {
                                case 'region':
                                    if(!childCounts[querySelection.country]) {
                                        _createChildCountObject(querySelection.country);
                                    }

                                    childCounts[querySelection.country].selectedRegions++;
                                    break;
                                case 'city':
                                    if(!childCounts[querySelection.country]) {
                                        _createChildCountObject(querySelection.country);
                                    }

                                    childCounts[querySelection.country].selectedCities++;
                                    break;
                                default:
                                    break;
                            }
                        });

                        this.currentOptions.forEach(function(countryOption) {
                            var countryKey = countryOption.key;

                            if(!this.isSelected(countryOption) && childCounts[countryKey]) {
                                if(childCounts[countryKey].selectedRegions >= countryOption.children.length) {
                                    this.addToDisplay(countryOption);
                                } else if(childCounts[countryKey].selectedRegions > 0) {
                                    this.partiallySelect(countryOption);
                                } else if(childCounts[countryKey].selectedCities > 0) {
                                    this.partiallySelect(countryOption);
                                }
                            }
                        }, this);
                    }

                };

                this.isSelected = function isSelected(option) {
                    if (this.displayState.selected[option.key]) {
                        if (option.parentKey) {
                            return (this.displayState.selected[option.key].parentKey === option.parentKey);
                        }
                        return true;
                    }
                    else if (this.displayState.selected[option.name]) {
                        if (option.parentKey) {
                            return (this.displayState.selected[option.name].parentKey === option.parentKey);
                        }
                        return true;
                    }
                    return false;
                };
            }

            LocationSelectionFactory.prototype = Object.create(FilterSelectionFactory.prototype);

            return LocationSelectionFactory;
        }
    ])
    .factory('BeatSelectionFactory', [
        'FilterSelectionFactory',
        function (FilterSelectionFactory) {
            'use strict';

            function BeatSelectionFactory(name) {
                FilterSelectionFactory.call(this, name);

                this.keyScheme = function keyScheme(option) {
                    var key = option.key;
                    if(option.parentKey) {
                        key += option.parentKey;
                    }
                    return key;
                };

                this.isSelected = function isSelected(option) {
                    return !!this.displayState.selected[this.keyScheme(option)];
                };

                this.updateRecentDisplay = function updateRecentDisplay() {
                    var selection;

                    this.displayState.selectedCount = this.selectedCurrentOptionCount();
                    if (this.displayState.selectedCount === 0) {
                        this.displayState.selectionDisplay = '';
                    } else if (this.displayState.selectedCount === 1) {
                        // the count will come back with 1, but the array may have parent and child
                        // need to loop through to display only the child
                        selection = Object.values(this.displayState.selected);
                        for (var i = 0; i < selection.length; i++) {
                            if (!this.hasChildren(selection[i])) {
                                this.displayState.selectionDisplay = selection[i].display;
                            }
                        }
                    } else {
                        this.displayState.selectionDisplay = this.name;
                    }
                };

                this.select = function select(option, updateAncestors) {
                    if (this.isPartiallySelected(option)) {
                        this.removePartialSelection(option);
                    }

                    this.displayState.selected[this.keyScheme(option)] = option;

                    this.updateAllSelected();

                    if(option.children) {
                        option.children.forEach(function(childOption) {
                            this.displayState.selected[this.keyScheme(childOption)] = childOption;
                        }, this);
                    }

                    if (updateAncestors) {
                        this.updateAncestors(option);
                    }
                    this.updateRecentDisplay();
                };

                this.deselect = function deselect(option, updateAncestors) {
                    if (this.isPartiallySelected(option)) {
                        this.removePartialSelection(option);
                    }

                    delete this.displayState.selected[this.keyScheme(option)];

                    this.displayState.allSelected = false;

                    if(option.children) {
                        option.children.forEach(function(childOption) {
                            delete this.displayState.selected[this.keyScheme(childOption)];
                        }, this);
                    }

                    if (updateAncestors) {
                        this.updateAncestors(option);
                    }
                    this.updateRecentDisplay();
                };
            }

            BeatSelectionFactory.prototype = Object.create(FilterSelectionFactory.prototype);

            return BeatSelectionFactory;
        }
    ]);